import React, { Fragment, useEffect } from 'react'

import './InformesHome.css'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChartBar } from '@fortawesome/free-solid-svg-icons'

import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'
import Header from '../Header/Header'

import { withRouter } from 'react-router-dom'

import { canAccessInformes, getInformesHubItems } from './informesHub'

const InformesHome = ({ history }) => {
    let token = JSON.parse(atob(sessionStorage.getItem('token').split('.')[1]))
    let rol = token.authorities[0]

    useEffect(() => {
        if (!canAccessInformes(rol)) history.goBack()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo icon={faChartBar} title={'Informes'} />
                </div>

                <div className="row">
                    {getInformesHubItems().map((item) => (
                        <div
                            key={item.path}
                            className="text-white bg-info col informes-home-card"
                            onClick={() => history.push(item.path)}
                        >
                            <h1>
                                <FontAwesomeIcon icon={faChartBar} />
                            </h1>
                            <h3>{item.title}</h3>
                        </div>
                    ))}
                </div>
            </div>
        </Fragment>
    )
}

export default withRouter(InformesHome)
